import { z } from 'zod';

export const FragmentSchema = z.object({
    video_url: z.string(),
    posterframe_url: z.string(),
    subtitles_url: z.string(),
});

export const AudiovisualSchema = z.object({
    title: z.string(),
});
